
<div class="step-section-card">
	<div class="step-section-text">
		<div class="d-flex flex-row justify-space-between align-start">
			<div
				:class="{ 'mt-3': showYesNoButtons }"
			>
				<h3 class="step-section-title">
					{{ title }}
				</h3>
				<p
					v-if="description"
					class="step-section-description mr-5"
				>
					{{ description }}
				</p>
			</div>
			<div
				v-if="showYesNoButtons"
				class="d-flex flex-row gap-2 yes-no-container"
			>
					<v-btn
						small
						:color="value === true ? 'primary' : 'default'"
						:outlined="value !== true"
						:disabled="disabled"
						class="yes-no-btn mr-2 text-none"
						@click="handleYesClick"
					>
						{{ yesButtonText }}
					</v-btn>
					<v-btn
						small
						:color="value === false ? 'primary' : 'default'"
						:outlined="value !== false"
						:disabled="disabled"
						class="yes-no-btn text-none"
						@click="handleNoClick"
					>
						{{ noButtonText }}
					</v-btn>
			</div>
		</div>
	</div>
	<div class="step-section-content">
		<slot />
	</div>
</div>
